// @ts-strict-ignore
import styled from "styled-components";
import { m } from "framer-motion";
import lightTheme from "themes/light";
import darkTheme from "themes/dark";
import { cn } from "app/_components/components/utils";

export const CollapseHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  margin: 0;
  padding-top: 24px;
`;
export const CollapseContainer = styled.div`
  scroll-margin-top: 100px;
  margin-top: 0;
  margin-bottom: 0;
  border-top: 1px solid
    ${({ theme, isMobileNav }) =>
      isMobileNav ? null : theme.borderColors.primary};
  ${({ isLast }) =>
    !!isLast &&
    `border-bottom: 1px solid ${({ theme, isMobileNav }) => (isMobileNav ? null : theme.borderColors.primary)};
`}
`;

export const CollapseBody = ({
  dark,
  isOpen = false,
  children,
  className
}: {
  dark?: boolean;
  isOpen?: boolean;
  children?: React.ReactNode;
  className?: string;
}) => {
  return (
    <m.div
      style={{
        color: dark
          ? darkTheme.textColors.primary
          : lightTheme.textColors.primary
      }}
      transition={{ duration: 0.2 }}
      animate={{ height: isOpen ? "auto" : 0 }}
      className={cn("tablet:pr-[96px] overflow-hidden pr-[26px]", className)}
    >
      {children}
    </m.div>
  );
};

export const CaretIcon = styled(m.div)`
  width: 10px;
  transform: rotate(90deg);
`;
